<template>
  <div class="detail-desc">
    <p>{{ prod.desc }}</p>
  </div>
</template>

<script>
export default {
  props: ["prod"]
};
</script>
